export { default as SpotlightSearchController } from './controllers/spotlight-search.controller';
